export default "__VITE_ASSET__b6799b1f__"